import type { NumberLinePayload } from '../../core/types/payloads/number_line.types';
import { buildNumberLineTicks } from './number_line.logic';

export const NUMBER_LINE_WIDTH = 560;
export const NUMBER_LINE_PADDING_X = 36;
export const NUMBER_LINE_AXIS_Y = 48;

export interface NumberLineTickPosition {
  tick: number;
  x: number;
  index: number;
}

export function buildNumberLineLayout(payload: Pick<NumberLinePayload, 'start' | 'end' | 'step'>) {
  const ticks = buildNumberLineTicks(payload.start, payload.end, payload.step);
  const usableWidth = NUMBER_LINE_WIDTH - NUMBER_LINE_PADDING_X * 2;
  const stepCount = Math.max(ticks.length - 1, 1);

  const positions: NumberLineTickPosition[] = ticks.map((tick, index) => ({
    tick,
    index,
    x: NUMBER_LINE_PADDING_X + (usableWidth * index) / stepCount,
  }));

  return {
    width: NUMBER_LINE_WIDTH,
    axisY: NUMBER_LINE_AXIS_Y,
    paddingX: NUMBER_LINE_PADDING_X,
    positions,
  };
}
